type MicroTask = (prev: any, error: any) => Promise<any>;

/**
 * 传入一系列返回 Promise 的函数，将顺序调用这样函数，并将上一个函数返回的 Promise resolve
 * 出来的值传递给下一个函数。 返回一个可以中断调用的函数
 * @param args 一系列返回 Promise 的函数
 * @return function 返回一个函数，调用后可以取消参数中还未执行的函数的执行
 */
export function canceableTask(...args: MicroTask[]) {
  let ternimal = false;
  let index = 0;
  function step(resultFromPrev: any, error: any) {
    if (index < args.length) {
      args[index]
        .call(null, resultFromPrev, error)
        .then((resolveResult: any) => {
          if (!ternimal) {
            index++;
            step(resolveResult, null);
          }
        })
        .catch((error: any) => {
          if (!ternimal) {
            index++;
            step(null, error);
          }
        });
    }
  }
  step(null, null);
  return () => {
    ternimal = true;
  };
}
